import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './styles/application.scss'

// AOS - Animate On Scroll
import AOS from 'aos';
import 'aos/dist/aos.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  mounted() {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    AOS.init({
      duration: reducedMotion ? 0 : 800,
      easing: 'ease-in-out',
      once: true,
      offset: 50,
      delay: reducedMotion ? 0 : 100,
      disable: reducedMotion,
    });
  },
}).$mount('#app');
